import { render, staticRenderFns } from "./Unser_Pflegekonzept.vue?vue&type=template&id=ed03b1fe&"
import script from "./Unser_Pflegekonzept.vue?vue&type=script&lang=js&"
export * from "./Unser_Pflegekonzept.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports